package org.multiplatform.kotfolio.pages.compose.side_effect

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
@Page("/compose/side_effect/saveable_state_holder")
@Composable
fun SaveableStateHolderPage() {
    BlogLayout(
        PageProperties(
            "SaveableStateHolder",
            ""
        ),
        BlogProperties("Jetpack Compose", "SaveableStateHolder"))
    {
        Column(
            horizontalAlignment = Alignment.Start
        ) {

            SpanText(
                text = "SaveableStateHolder",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When implementing dynamic or multi-screen in Jetpack Compose, preserving and restoring the state of individual screens during navigation or configuration changes can be challenging. This is where SaveableStateHolder56 comes into play.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It ensures that composables retain their state even when they are temporarily removed from the composition, such as during navigation or screen transitions",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "SaveableStateHolder is a Compose Runtime API that works alongside rememberSaveable to manage and preserve the state of composables associated with a unique key. When a composable is removed from the composition (e.g., navigating to a new screen), its state is saved and restored automatically when it re-enters the composition.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    @Composable
                    fun <T : Any> Navigation(
                        currentScreen: T,
                        modifier: Modifier = Modifier,
                        content: @Composable (T) -> Unit
                    ) {
                        // Create SaveableStateHolder
                        val saveableStateHolder = rememberSaveableStateHolder()

                        Box(modifier) {
                            // Save state for each screen
                            saveableStateHolder.SaveableStateProvider(currentScreen) {
                                content(currentScreen)
                            }
                        }
                    }
                    
                    enum class Screen {
                        HOME,
                        PROFILE
                    }

                    @Composable
                    fun App(current: Screen) {
                        Navigation(currentScreen = current) { screen ->
                            when (screen) {
                                Screen.HOME -> HomeScreen()
                                Screen.PROFILE -> ProfileScreen()
                            }
                        }
                    }
                    
                    @Composable
                    fun HomeScreen() {
                        var text by rememberSaveable { mutableStateOf("") }

                        TextField(
                            value = text,
                            onValueChange = { text = it }
                        )
                    }
                    
                    //var counter by rememberSaveable { mutableStateOf(0) }
                    """.trimIndent()
            )
        }
    }
}